import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/img/about/profile-pic.jpg'


const _hoisted_1 = {
  id: "about",
  class: "page"
}
const _hoisted_2 = { class: "page-content default" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "About Me", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("section", { id: "intro" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Profile Picture"
  }),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Hello! My name's "),
    /*#__PURE__*/_createElementVNode("strong", null, "Ji Ho Oh"),
    /*#__PURE__*/_createTextVNode(" (오지호) but most people call me "),
    /*#__PURE__*/_createElementVNode("strong", null, "Jay"),
    /*#__PURE__*/_createTextVNode(". With a degree in Computational Mathematics from the University of Waterloo under my belt, I'm currently working for Ford Motor Company as an Android Developer."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I like making things that are "),
    /*#__PURE__*/_createElementVNode("span", { id: "wave" }, [
      /*#__PURE__*/_createElementVNode("span", null, "『"),
      /*#__PURE__*/_createElementVNode("span", null, "ａ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｅ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｓ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｔ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｈ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｅ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｔ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｉ"),
      /*#__PURE__*/_createElementVNode("span", null, "ｃ"),
      /*#__PURE__*/_createElementVNode("span", null, "』")
    ]),
    /*#__PURE__*/_createTextVNode(" , which is why I'm drawn to designing and developing front-end applications like websites and Android apps. Right now, I'm focusing on expanding my repetoire by exploring a variety of libraries and frameworks. I'm always on the lookout for new ways to elevate my work."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Apart from coding, I have a wide range of creative interests. Whether I'm capturing moments through my lens, creating stories for my tabletop campaign, or shredding on my electric guitar, I'm always seeking inspiration from the world around me. ")
  ])
], -1)
const _hoisted_5 = { id: "experience" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Experience", -1)
const _hoisted_7 = { id: "experience-content" }
const _hoisted_8 = { id: "timeline" }
const _hoisted_9 = { class: "navigation-bar-scroll-wrapper" }
const _hoisted_10 = { class: "navigation-bar-content" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExperienceCard = _resolveComponent("ExperienceCard")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("section", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experiences, (experience, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    onClick: ($event: any) => (_ctx.activeExperience = experience),
                    class: _normalizeClass({ active: _ctx.activeExperience === experience })
                  }, _toDisplayString(experience.employer), 11, _hoisted_11))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_Transition, {
            name: "flicker",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ExperienceCard, { activeExperience: _ctx.activeExperience }, null, 8, ["activeExperience"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}